import axios from 'axios';
import {CUSTODIA_GARANTIA_SERVICE_CONTEXT} from "../../utils/constants/ContextConstants";

export class CustodyBBVAService {
    getCustodyData() {
        /**
         * Colocar url de endpoint del back
         */
        return axios.get(CUSTODIA_GARANTIA_SERVICE_CONTEXT + 'login', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data);
    }

    updateCustodyData(userName, password, domain, trustClient) {
        let formData = {
            username: userName,
            password: password,
            baseUrl: domain,
            trustClient: trustClient,
        };
        return axios.put(CUSTODIA_GARANTIA_SERVICE_CONTEXT + 'login', formData, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data);
    }

    getInstitutionsData() {
        return axios.get(CUSTODIA_GARANTIA_SERVICE_CONTEXT + 'institutions', {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data);
    }

    updateInstitutionsData(listInstitutions){//setAutomatic

        return axios.put(CUSTODIA_GARANTIA_SERVICE_CONTEXT + 'institutions/setAutomatic', listInstitutions, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(res => res.data);

    }
}